/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-04-23T14:56:33.846
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentGoods,
	getRentGoodsCreateInit,
	getRentGoodsEditInit,
	getRentGoodsView,
	deleteRentGoods
} from '@api/rentmanage/RentGoods';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentGoodsCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentGoodsCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentGoodsEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentGoodsEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentGoods({}, RentGoods) {
			return new Promise((resolve, reject) => {
				saveRentGoods(RentGoods)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentGoodsView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentGoodsView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentGoods({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentGoods({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
